<template>
  <div class="auth-header">
    <router-link to="/statements" tag="a" class="w3-bar-item w3-button w3-theme-d4" style="padding:10px 12px 10px 12px">
      <img src='../assets/jybe_lg.svg' height='30px' />
    <!-- 
    <span style="font-family: 'Roboto'; font-style: italic; font-weight: 900; font-size:24px">J</span>
    <span style="font-family: 'Roboto Condensed'; font-style: normal; font-weight: 700; font-size:18px; position:relative; left:-2px; top:-2px">ybe</span>
    -->      
    </router-link>
    <router-link to="/convos" tag="a" class="w3-bar-item w3-button w3-padding-large w3-hover-white" title="Conversations">
      <font-awesome-icon :icon="['fas', 'comments']" />
    </router-link>
    <a v-if="isAuthenticated" @click="newConvo()" class="w3-bar-item w3-button w3-hover-white" title="Start a Conversation" style="padding: 13px 12px 11px 6px">
    <font-awesome-icon :icon="['fal', 'comments']" />
    <font-awesome-icon :icon="['fal', 'plus']" style="position:relative; left:-2px;" />
    </a>
    <router-link to="/feedback" tag="a" class="w3-bar-item w3-button w3-right w3-padding-large w3-hover-white w3-hide-small" title="Feedback">
      Feedback
    </router-link>
    <router-link to="/about" tag="a" class="w3-bar-item w3-button w3-right w3-padding-large w3-hover-white w3-hide-small" title="About">
      About
    </router-link>
    <router-link v-if="isAuthenticated" to="/logout" tag="a" class="w3-bar-item w3-button w3-right w3-padding-large w3-hover-white w3-hide-small" title="Logout">
     Logout
    </router-link>
    <a v-else @click="login()" class="w3-bar-item w3-button w3-right w3-padding-large w3-hover-white w3-hide-small" title="Login">
      Login
    </a>
    <a class="w3-bar-item w3-button w3-hide-medium w3-hide-large w3-right w3-padding-large w3-hover-white w3-large w3-theme-d2" @click="openNav()">
      <i class="fa fa-bars"></i>
    </a>
    <div v-if="isNavOpen" class="w3-bar-block w3-theme-d2 w3-hide-large w3-hide-medium w3-large" @click="openNav()">
      <router-link v-if="isAuthenticated" to="/logout" tag="a" class="w3-bar-item w3-button w3-padding-large" title="Logout">
       Logout
      </router-link>
      <a v-else @click="login()" class="w3-bar-item w3-button w3-padding-large w3-hover-white" title="Login">
        Login
      </a>
      <router-link to="/about" tag="a" class="w3-bar-item w3-button w3-padding-large" title="About">
        About
      </router-link>
      <router-link to="/feedback" tag="a" class="w3-bar-item w3-button w3-padding-large" title="Feedback">
        Feedback
      </router-link>
    </div>
    <!-- Navbar on small screens -->
    <!--   
      <div id="navDemo" class="w3-bar-block w3-theme-d2 w3-hide w3-hide-large w3-hide-medium w3-large">
        <a href="#" class="w3-bar-item w3-button w3-padding-large">Link 1</a>
        <a href="#" class="w3-bar-item w3-button w3-padding-large">Link 2</a>
        <a href="#" class="w3-bar-item w3-button w3-padding-large">Link 3</a>
        <a href="#" class="w3-bar-item w3-button w3-padding-large">My Profile</a>
      </div>
    -->

  </div>
</template>

<script>
  import AuthHeader from './AuthHeader.ts'
  export default AuthHeader
</script>
